import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Trans, useTranslation } from 'react-i18next';

import { NoResultsFoundIcon } from '@/assets/icons/NoResultsFoundIcon';

import { autocompleteDropdownNoOptionsStyles as sx } from './AutocompleteDropdownNoOptions.styles';

type Props = {
	query: string;
	alreadySelected?: boolean;
};

export const AutocompleteDropdownNoOptions = ({
	query,
	alreadySelected = false
}: Props) => {
	const { t } = useTranslation();

	return (
		<Box sx={sx.root}>
			<NoResultsFoundIcon sx={sx.searchIcon} />

			<Box sx={sx.description}>
				<Box sx={sx.text}>
					{!query ? (
						t('No results found.')
					) : alreadySelected ? (
						<Trans
							defaults='<bold>{{query}}</bold> is already selected.'
							values={{ query: query }}
							components={{
								bold: (
									<Typography
										sx={sx.query}
										variant='body1'
										color='textFadedPrimary'
									/>
								)
							}}
						/>
					) : (
						<Trans
							defaults='No results for <bold>{{query}}</bold>.'
							values={{ query: query }}
							components={{
								bold: (
									<Typography
										sx={sx.query}
										variant='body1'
										color='textFadedPrimary'
									/>
								)
							}}
						/>
					)}
				</Box>

				{!alreadySelected && query && (
					<Box sx={sx.text}>{t('Try a different search term.')}</Box>
				)}
			</Box>
		</Box>
	);
};
